import { DateTime, Interval } from 'luxon';
import { Location, TimeInterval } from '../clients/quipli-service/location/location';

export interface LocationInterval {
  disabledIntervals: Interval[];
  enabledIntervals: Interval[];
}

export const startEndDateHours = (
  startDateTime: DateTime | undefined,
  endDateTime: DateTime | undefined,
  location: Location,
  onlyShowStoreHoursOnDateTimePicker: boolean,
): { startDaysHours: TimeInterval | undefined; endDaysHours: TimeInterval | undefined } => {
  const startDaysHours =
    onlyShowStoreHoursOnDateTimePicker && startDateTime
      ? location.hoursOfOperation.find((ho) => ho.numericDayOfWeek === startDateTime.weekday)?.rentalStart || {
          start: '23:59',
          end: '00:00',
        }
      : undefined;
  const endDaysHours =
    onlyShowStoreHoursOnDateTimePicker && endDateTime
      ? location.hoursOfOperation.find((ho) => ho.numericDayOfWeek === endDateTime.weekday)?.rentalEnd || {
          start: '23:59',
          end: '00:00',
        }
      : undefined;

  return { startDaysHours, endDaysHours };
};
